import { Base } from "../Base";
import { system } from "../system";
import { Restriction } from "./Restriction";
export class Class extends Base {
    allowed;
    class = "number";
    name = "number";
    get definition() {
        return Object.assign(super.definition, this.allowed === undefined ? {} : { allowed: this.allowed });
    }
    constructor(allowed) {
        super();
        this.allowed = allowed;
    }
    is(value) {
        return typeof value == "number" && system.Number.isFinite(value);
    }
    restrict(...restriction) {
        return super.restrict(...(Base.Restriction.is(restriction) ? restriction : Restriction.convert(restriction)));
    }
    static create(...restriction) {
        const result = new Class();
        return ((value) => Array.isArray(value) && value.length == 0)(restriction)
            ? result
            : result.restrict(...restriction);
    }
}
//# sourceMappingURL=Class.js.map